import { render, staticRenderFns } from "./addSupplier.pug?vue&type=template&id=854b7108&lang=pug&"
import script from "./addSupplier.ts?vue&type=script&lang=ts&"
export * from "./addSupplier.ts?vue&type=script&lang=ts&"
import style0 from "./addSupplier.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports